module.exports = __webpack_public_path__ + "img/swiper-2.29bd1244.png";